// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2623817596f6eaa2ece6","655":"d7f648ba5ed68098bf74"}[chunkId] + ".js";
};